import { render, staticRenderFns } from "./index.vue?vue&type=template&id=02b274b9&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryCollectionsFilterSearch: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/CategoryCollectionsFilterSearch/index.vue').default,CategoryCollectionsFilterFilters: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/CategoryCollectionsFilterFilters/index.vue').default,EntityFiltersWrapper: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/EntityFiltersWrapper/index.vue').default,Section: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Section/index.vue').default})
